export default __webpack_public_path__ + "static/media/Ballroll_00217.db441e36.png";